var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
if (typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var GridInteraction = require("../../../abstract/gridInteraction.js");
var AbstractPosAngleInteractionModel = require("../../../abstract/abstractPosAngleInteractionModel.js");
var cio_config = require("cio-config");

var EllipseInteractionModel = function (ellipseData, editorModel, options) {
    AbstractPosAngleInteractionModel.call(this, ellipseData, editorModel);

    this.addGridInteraction(this, editorModel);

    this.origin = editorModel.origin();
    this.editorModel = editorModel;
    this.options = options || {};

    this.isEllipseIM = true;

    this.showStrokeWidth = this.shadow("showStrokeWidth",
        function () {
            return this.data.strokeWidth() / this.origin.getGridFactor();
        },
        function (strokeWidth) {
            return this.data.strokeWidth(Math.abs(strokeWidth || 0) * this.origin.getGridFactor());
        },
        [this.data.strokeWidth, this.origin.grid_unit]
    );

    this.showWidth = this.shadow("showWidth",
        function () {
            return this.data.width() / this.origin.getGridFactor();
        },
        function (width) {
            return this.data.width((width || 0) * this.origin.getGridFactor());
        },
        [this.data.width, this.origin.grid_unit]
    );

    this.showHeight = this.shadow("showHeight",
        function () {
            return this.data.height() / this.origin.getGridFactor();
        },
        function (height) {
            return this.data.height((height || 0) * this.origin.getGridFactor());
        },
        [this.data.height, this.origin.grid_unit]
    );
};
lib_core.inherit(EllipseInteractionModel, AbstractPosAngleInteractionModel);
lib_core.mixin(EllipseInteractionModel, GridInteraction);
lib_core.JsonParser.registerClass(EllipseInteractionModel, "EllipseInteractionModel");

module.exports = EllipseInteractionModel;

EllipseInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.push(
        {
            label: 'Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showWidth,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Height',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showHeight,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Stroke Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showStrokeWidth,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Fill',
            type: ui_extensions.InspectorInputType.CHECKBOX,
            datamember: this.data.fill
        }
    );

    inspectorElements.help_elements = {
        'name': 'Ellipse'
    };

    return inspectorElements;
};

EllipseInteractionModel.prototype.getSnapSet = function (type) {
    var snapSet = AbstractPosAngleInteractionModel.prototype.getSnapSet.call(this, type);
    return snapSet;
};

EllipseInteractionModel.prototype.width = function (val) {
    return this.data.width(val);
};

EllipseInteractionModel.prototype.height = function (val) {
    return this.data.height(val);
};
